import { ColorSchemeUpdater } from "@/components/ColorSchemeUpdater.tsx";
import { MobileMenuProvider } from "@/components/layouts/MobileMenuProvider.tsx";
import { Navbar } from "@/components/layouts/Navbar.tsx";
import { Sidebar } from "@/components/layouts/Sidebar.tsx";
import { useNavbar } from "@/hooks/useNavbar.ts";
import { Aside, Grid, Main, useResponsiveValue } from "@hopper-ui/components";
import { PageLoading, SidePanel, SidePanelAsModal, useSidePanel } from "@workleap-ai/shared";
import { Suspense } from "react";
import { Outlet, useLocation } from "react-router";

export const RootLayout = () => {
    useNavbar();

    const location = useLocation();
    const { isTransitionComplete, isSidePanelOpen, handleTransitionEnd, handleTransitionStart } = useSidePanel();

    const templateColumns = useResponsiveValue({
        base: ["1fr", "0"],
        lg: ["1fr", isSidePanelOpen ? "25rem" : "0"]
    });

    const isModal = useResponsiveValue({
        base: true,
        lg: false
    });

    return (
        <MobileMenuProvider>
            <ColorSchemeUpdater />
            <Grid
                areas={["navbar navbar", "sidebar body"]}
                UNSAFE_templateColumns={{ base: ["core_0", "1fr"], sm: ["var(--wai-sidebar-width)", "1fr"] }}
                templateRows={["auto", "1fr"]}
            >
                <Navbar />
                <Sidebar />
                <Grid
                    gridArea="body"
                    areas={["main sidepanel"]}
                    UNSAFE_templateColumns={templateColumns}
                    onTransitionStart={handleTransitionStart}
                    onTransitionEnd={handleTransitionEnd}
                    style={{
                        transition: "grid-template-columns 0.3s ease"
                    }}
                >
                    <Main
                        gridArea="main"
                        minWidth="core_0"
                        UNSAFE_height="calc(100dvh - var(--wai-navbar-height))"
                    >
                        <Suspense fallback={<PageLoading />} key={location.pathname}>
                            <Outlet />
                        </Suspense>
                    </Main>
                    {isModal ? <SidePanelAsModal /> :
                        <Aside
                            gridArea="sidepanel"
                            UNSAFE_height="calc(100dvh - var(--wai-navbar-height))"
                            overflow="hidden"
                            borderLeft="neutral-weak"
                        >
                            {isTransitionComplete && <SidePanel />}
                        </Aside>
                    }
                </Grid>
            </Grid>
        </MobileMenuProvider>
    );
};
